/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_Views_AriaInputs */

const en_directory_home_board_views_aria = /** @type {(inputs: Directory_Home_Board_Views_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product board views`)
};

const zh_directory_home_board_views_aria = /** @type {(inputs: Directory_Home_Board_Views_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品榜单视图`)
};

/**
* | output |
* | --- |
* | "Product board views" |
*
* @param {Directory_Home_Board_Views_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_views_aria = /** @type {((inputs?: Directory_Home_Board_Views_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_Views_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_views_aria(inputs)
	return zh_directory_home_board_views_aria(inputs)
});
export { directory_home_board_views_aria as "directory.home.board.views_aria" }